import { Product } from '@nemuru-eng/js-api-client';

import { GetTextIdTranslationType } from '@/components/shared/hooks/useTranslation';

import { programsByProductMap } from './programsByProductMap';

export const ProgramOptions = (product: Product, t: GetTextIdTranslationType) =>
  programsByProductMap(product).map((program) => ({
    value: program.toLowerCase(),
    display: t(program.toLowerCase()) || program.toLowerCase(),
  }));
